import { AccessKeys, LocalStorageAccessKeys } from "../models";

export const setCurrentClientIdAndProjectId = ({ clientId, projectId, projectType, tab }: AccessKeys) => {
  tab && localStorage.setItem(LocalStorageAccessKeys.TAB, tab);
  clientId && localStorage.setItem(LocalStorageAccessKeys.CLIENT_ID, clientId);
  projectId && localStorage.setItem(LocalStorageAccessKeys.PROJECT_ID, projectId);
  projectType && localStorage.setItem(LocalStorageAccessKeys.PROJECT_TYPE, projectType);
}
